import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Grid, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Button } from "@mui/material";
import { Pagination } from "../Pagination";
import ascSortingSelected from "../../asset/image/ascSortingSelected.svg";
import descSortingSelected from "../../asset/image/descSortingSelected.svg";
import AscSort from "../../asset/image/AscSort.svg";
import DescSort from "../../asset/image/DescSort.svg";
import { getDecodeURI, getEncodedURI } from "../../utils/util";
import { useEffect, useState } from "react";
import _ from "lodash";
import { getContentFilterTopUsersTable } from '../../actions/Users/authenticateContentFilter';
import Download from '../../asset/image/DownloadUsage.svg';
import { CsvParameters, downloadAsCSV } from "../../actions/Users/authenticateCsvDownload";
import DownloadCSV, { clearCsvDownload } from "../DownloadCSV";
import { GET_CF_TOP_USERS_TABLE_COUNT, GET_CSV_DATA_TO_DOWNLOAD } from "../../actions/types";
import { toast } from "react-toastify";

const convertToCsvContentFilter = (data: any[][]) => {
    const [_columns, ...rows] = data;
    const csvRows: any[] = [];
    rows.forEach(row => {
        csvRows.push([row[4], row[5], row[6], row[0], row[2], row[3], row[9], row[10], row[8], row[7]])
    })
    return [['Device Alias', 'Client', 'MAC Address', 'Site Name', 'Device Name', 'VLAN', 'Top Category', 'Top Sub Category', 'Top Domains', 'Hits'], ...csvRows]
}

const ContentFilterTable = (props) => {
    const { authReducer, values, setValues, getContentFilterTopUsersTable, applyFilterClick, newSummaryStartDate, newSummaryEndDate, location, history, downloadAsCSV } = props;
    const { vessels, category, app, user, vlan, device, subCategory, page, limit, sort, sortOrder} = values;
    const { setCategory, setApp, setUser, setVlan, setDevice, setSubCategory, setPage, setLimit, setSort, setSortOrder } = setValues;
    const SITENAME = 'Site_Name';
    const DEVICENAME = 'Device_Name';
    const USERNAME = 'Username';
    const FQDN = 'fqdn';
    const ACCESSNETWORK = 'Access_Network';
    const CLIENT = 'client';
    const MACADDRESS = 'mac';
    const HITS = 'User_hits';
    const CATEGORY = 'Top_Category';
    const SUB_CATEGORY = 'Top_SubCategory';
    const ASC_ORDER = "asc";
    const DESC_ORDER = "desc";
    const [tableData, setTableData] = useState<any>([]);
    const dispatch = useDispatch();

    useEffect(() => {
        if(vessels.length == 0) {
            setTableData([]);
            dispatch({
                type: GET_CF_TOP_USERS_TABLE_COUNT, payload: {
                    data: {
                        rows: [[0]]
                    }
                }
            });
        }
     }, [vessels])

    useEffect(() => {
        if(!_.isEmpty(authReducer.getContentFilterTopUsersTable)) {
            const data = authReducer.getContentFilterTopUsersTable.hasOwnProperty('data') ? authReducer.getContentFilterTopUsersTable?.data : {};
            const tableData = data?.rows?.map((item) => {
                return data?.columns?.reduce((acc, columItem, i) => {
                    acc[columItem] = item[i];
                    return acc;
                }, {})
            })
            setTableData(tableData);
        }
    }, [authReducer.getContentFilterTopUsersTable])

    
    useEffect(() => {
        if (!authReducer.csvDataDownloded || !authReducer.csvDataDownloded.length) return;
        if (authReducer.csvDownloadId !== 'top-users') return;
        DownloadCSV(convertToCsvContentFilter(authReducer.csvDataDownloded), {
            formatters: {
                3: 'ESC-COMMA',
                4: 'ESC-COMMA',
                6: 'ESC-COMMA',
                7: 'ESC-COMMA',
                8: 'ESC-COMMA'
            }
        });
        return () => {
            dispatch(clearCsvDownload())
        }
    }, [authReducer.csvDataDownloded])

    const handleChangePage = (e, value) => {
        let params: any = getDecodeURI(location?.search);
        value == 1 ? delete params.page : params.page = value;
        setPage(value);
        doNavigate(params);
        vessels.length > 0 && getContentFilterTopUsersTable(newSummaryStartDate, newSummaryEndDate, vessels, category, app, user, vlan, device, subCategory, value, limit, sort, sortOrder)
    };

    const handleChangeRowsPerPage = (e) => {
        const Limit = parseInt(e.target.value);
        let params: any = getDecodeURI(location?.search);
        delete params.page;
        Limit == 10 ? delete params.limit : params.limit = Limit
        setPage(1);
        setLimit(Limit);
        doNavigate(params);
        vessels.length > 0 && getContentFilterTopUsersTable(newSummaryStartDate, newSummaryEndDate, vessels, category, app, user, vlan, device, subCategory, 1, Limit, sort, sortOrder)
    };

    const Sorting = (sortcolumn, sortOrd) => {
        let params: any = getDecodeURI(location?.search);
        delete params.page;
        params.sort = sortcolumn;
        params.sortOrder = sortOrd;
        const Page = 1;
        setPage(1);
        setSort(sortcolumn);
        setSortOrder(sortOrd);
        doNavigate(params);
        vessels.length > 0 && getContentFilterTopUsersTable(newSummaryStartDate, newSummaryEndDate, vessels, category, app, user, vlan, device, subCategory, Page, limit, sortcolumn, sortOrd)
    }

    const setSorting = (event: any, field: any, order: any,) => {
        if (event && event.currentTarget) {
            Sorting(field, order)
        }
    };

    const switchSorting = (event: any, field: any) => {
        let order = ASC_ORDER;
        if (sort === field) {
            order = ASC_ORDER === sortOrder ? DESC_ORDER : ASC_ORDER;
        }
        Sorting(field, order)
    };

    const handleApplyFilter = (row, key) => {
        switch(key) {
            case 'app': {
                const value = row;
                setApp(value);
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, vessels, category, value, user, vlan, device, subCategory);
                break;
            }
            case 'user': {
                const value = row.Username;
                setUser(value);
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, vessels, category, app, value, vlan, device, subCategory);
                break;
            }
            case 'client': {
                const value = row.client;
                setUser(value);
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, vessels, category, app, value, vlan, device, subCategory);
                break;
            }
            case 'mac': {
                const value = row.mac;
                setUser(value);
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, vessels, category, app, value, vlan, device, subCategory);
                break;
            }
            case 'vlan': {
                const value = row.Access_Network;
                setVlan(value);
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, vessels, category, app, user, value, device, subCategory);
                break;
            }
            case 'device': {
                const value = row.Device_Name;
                setDevice(value);
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, vessels, category, app, user, vlan, value, subCategory);
                break;
            }
            case 'category': {
                const value = row.Top_Category;
                setCategory(value);
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, vessels, value, app, user, vlan, device, subCategory);
                break;
            }
            case 'subCat': {
                const value = row.Top_SubCategory;
                setSubCategory(value);
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, vessels, category, app, user, vlan, device, value);
                break;
            }
            case 'site': {
                const value = [{id: row.location_id, 'vessel-name': row.Site_Name, }];
                applyFilterClick(newSummaryStartDate, newSummaryEndDate, value, category, app, user, vlan, device, subCategory, 'filter');
                break;
            }
        }
    }

    const doNavigate = (params) => {
        history.push({ pathname: location.pathname, search: `?${getEncodedURI(params)}` });
    }

    const rowsOption = [10, 15, 25, 50, 100];

    const handleDownloadReport = () => {
        let isClickHouse = true;
        if (vessels.length === 0) {
            toast.error("No data available to download", {
                position: toast.POSITION.BOTTOM_LEFT,
            })
            return;
        }
        // const vesselMap: any = vessels?.map((item: any) => item["id"])
        // let k4idhere = vesselMap.length > 0 ? `${"'" + vesselMap.join("','") + "'"}` : null;
        if (authReducer?.getContentFilterTopUsersTableCount) {
            const params: CsvParameters = {
                type: isClickHouse ? 'QUERY_CH' : 'QUERY',
                id: 'top-users',
                queryName: 'CONTENT_FILTER_TOP_USERS_TABLE',
                payload: {
                    start_time: newSummaryStartDate,
                    end_time: newSummaryEndDate,
                    location_ids: vessels && vessels.length > 0 ? `${vessels.map((item: any) => `'${item.id}'`).join(",")}` : '',
                    category: category ? `and category='${category}'` : '',
                    application: app ? `and fqdn='${app}'` : '',
                    hostname: user ? `and (Username LIKE '%${user}%' OR client LIKE '%${user}%' OR mac LIKE '%${user}%')` : '',
                    vlan: vlan ? `and Access_Network='${vlan}'` : '',
                    devicename: device ? `and Device_Name='${device}'` : '',
                    subcategory: subCategory ? `and subcategory='${subCategory}'` : '',
                    sortcolumn: sort,
                    sortorder: sortOrder,
                    pageoffset: 0,
                    pagesize: authReducer?.getContentFilterTopUsersTableCount?.data?.rows?.[0]?.[0]
                }
            }
            downloadAsCSV(params);
        }

    }

    return (
        <div className="config-container">
            <Grid container spacing={0.5} className="reports-login-history">
            <Grid item xs={12} sm={12} md={12} lg={12} className="firewall-table-download">
                <Grid item xs={6} sm={6} md={6} lg={6} className="Reports-overView-topUsers align-text-center">Top Users</Grid>
                    {authReducer?.getContentFilterTopUsersTableCount?.data?.rows?.[0]?.[0] > 0 && <Grid item xs={6} sm={6} md={6} lg={6}>
                        <div className="download-summary-btn marg-left-auto" onClick={handleDownloadReport}><img className="downloadImg" src={Download} alt="" /><Button>Download</Button></div>
                    </Grid>}
            </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} className="TopUsersConatiner content-filter-table-container">
                    <Paper className="pagination-position config-pagination CF-usage">
                        <Pagination
                            rowsPerPageOptions={rowsOption}
                            count={authReducer?.getContentFilterTopUsersTableCount?.data?.rows?.[0]?.[0]}
                            rowsPerPage={limit}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Paper>
                    <TableContainer className="usageReports-FleetDashboard loginHistory-tableContainer">
                        <Table aria-label="simple sticky table" stickyHeader>
                            <TableHead className="usageReports-tableHead">
                                <TableRow className="UsageReports-tableRow login-tableRow">
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell" style={{textAlign: "left"}}>
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, USERNAME)}>DEVICE ALIAS</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === USERNAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, USERNAME, ASC_ORDER)} />
                                                <img src={sort === USERNAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, USERNAME, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, CLIENT)}>CLIENT</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === CLIENT && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, CLIENT, ASC_ORDER)} />
                                                <img src={sort === CLIENT && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, CLIENT, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, MACADDRESS)}>MAC ADDRESS</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === MACADDRESS && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, MACADDRESS, ASC_ORDER)} />
                                                <img src={sort === MACADDRESS && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, MACADDRESS, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, SITENAME)}>SITE NAME</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === SITENAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, SITENAME, ASC_ORDER)} />
                                                <img src={sort === SITENAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, SITENAME, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, DEVICENAME)}>DEVICE NAME</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === DEVICENAME && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, DEVICENAME, ASC_ORDER)} />
                                                <img src={sort === DEVICENAME && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, DEVICENAME, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, ACCESSNETWORK)}>VLAN</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === ACCESSNETWORK && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, ACCESSNETWORK, ASC_ORDER)} />
                                                <img src={sort === ACCESSNETWORK && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, ACCESSNETWORK, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" >TOP CATEGORY</span>
                                            {/* <Grid className="sort-icon-margin">
                                            onClick={(event) => switchSorting(event, CATEGORY)}
                                                <img src={sort === CATEGORY && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, CATEGORY, ASC_ORDER)} />
                                                <img src={sort === CATEGORY && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, CATEGORY, DESC_ORDER)} />
                                            </Grid> */}
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" >TOP SUB CATEGORY</span>
                                            {/* <Grid className="sort-icon-margin">
                                            onClick={(event) => switchSorting(event, SUB_CATEGORY)}
                                                <img src={sort === SUB_CATEGORY && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, SUB_CATEGORY, ASC_ORDER)} />
                                                <img src={sort === SUB_CATEGORY && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, SUB_CATEGORY, DESC_ORDER)} />
                                            </Grid> */}
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" >TOP DOMAINS</span>
                                            {/* <Grid className="sort-icon-margin">
                                            onClick={(event) => switchSorting(event, FQDN)}
                                                <img src={sort === FQDN && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, FQDN, ASC_ORDER)} />
                                                <img src={sort === FQDN && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, FQDN, DESC_ORDER)} />
                                            </Grid> */}
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell CF-cell">
                                        <span className="table-cell-span align-items-center">
                                            <span className="login-history-dp-name font-wt-900" onClick={(event) => switchSorting(event, HITS)}>HITS</span>
                                            <Grid className="sort-icon-margin">
                                                <img src={sort === HITS && sortOrder === ASC_ORDER ? ascSortingSelected : AscSort}
                                                    className="ascendingOrderIcon sortingImages" onClick={(event) => setSorting(event, HITS, ASC_ORDER)} />
                                                <img src={sort === HITS && sortOrder === DESC_ORDER ? descSortingSelected : DescSort}
                                                    className="sortingImages" onClick={(event) => setSorting(event, HITS, DESC_ORDER)} />
                                            </Grid>
                                        </span>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            {0 != tableData?.length ? (
                                <TableBody className="tableBody usage-tableBody">
                                    {
                                        tableData && tableData.map((row, i) =>
                                            <TableRow key={i} className="loginHistory-tableRow">
                                                <TableCell className={row['Username'] != 'NA' ? "login-left-align selectedClick" : "login-left-align"} onClick={() => handleApplyFilter(row, 'user')}>{row['Username']}</TableCell>
                                                <TableCell className='login-left-align selectedClick' onClick={() => handleApplyFilter(row, 'client')}>{row['client']}</TableCell>
                                                <TableCell className='login-left-align selectedClick' onClick={() => handleApplyFilter(row, 'mac')}>{row['mac']}</TableCell>
                                                <TableCell className="login-left-align selectedClick" onClick={() => handleApplyFilter(row, 'site')}>{row['Site_Name']}</TableCell>
                                                <TableCell className="login-left-align selectedClick" onClick={() => handleApplyFilter(row, 'device')}>{row['Device_Name']}</TableCell>
                                                <TableCell className="login-left-align selectedClick" onClick={() => handleApplyFilter(row, 'vlan')}>{row['Access_Network']}</TableCell>
                                                <TableCell className='login-left-align selectedClick' onClick={() => handleApplyFilter(row, 'category')}>{row['Top_Category']}</TableCell>
                                                <TableCell className='login-left-align selectedClick' onClick={() => handleApplyFilter(row, 'subCat')}>{row['Top_SubCategory']}</TableCell>
                                                <TableCell className="login-left-align selectedClick">
                                                    {row['Top_domains']?.split(',')?.map((dm, j) => (
                                                        <div key={j} onClick={() => handleApplyFilter(dm, 'app')}>{dm}</div>
                                                        ))}
                                                </TableCell>
                                                <TableCell className="login-left-align">{row['User_hits']}</TableCell>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={10} className="noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    newSummaryStartDate: state.authReducer.newSummaryStartDate,
    newSummaryEndDate: state.authReducer.newSummaryEndDate,
    errorReducer: state.errorReducer,
});

export default withRouter(
    connect(mapStateToProps, { getContentFilterTopUsersTable, downloadAsCSV })(ContentFilterTable)
);